import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LabOSView from '../views/LabOSView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'labos',
    component: LabOSView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'labos-catch-all',
    component: LabOSView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
